(function () {
  'use strict';

  angular.module('sempraWebapp').component('rolloverSpeed', {
    templateUrl: 'app/facilityKarcherDetails/rolloverSpeed/rolloverSpeed.html',
    controller: rolloverSpeed,
    bindings: {
      speedList: '<',
      activation: '&',
      defaultVisibilityState: '<'
    },
    controllerAs: 'vm'
  });

  function rolloverSpeed() {
    var vm = this;

    vm.$onInit = function () {
      if (!vm.speedList) {
        return;
      }
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState ? 'expand_less' : 'expand_more';
      vm.speedList.map(function (item) {
        if (item.name === 'DRYING_LOW_NOISE') {
          item.sliderMin = 50;
          item.sliderMax = 100;
        } else {
          item.sliderMin = 70;
          item.sliderMax = 130;
        }
      });
    };

    vm.$onChanges = function () {};

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState ? 'expand_less' : 'expand_more';
    };

    vm.sliderLimits = {
      min: 70,
      max: 130
    };

    vm.updateSpeed = function (dataToUpdate) {
      vm.activation({
        data: dataToUpdate
      });
    };
  }
})();
